import { render } from "./BlockComponent.vue?vue&type=template&id=17bd5f85"
import script from "./BlockComponent.vue?vue&type=script&lang=js"
export * from "./BlockComponent.vue?vue&type=script&lang=js"

import "./BlockComponent.vue?vue&type=style&index=0&id=17bd5f85&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__